import { render, staticRenderFns } from "./department-field.vue?vue&type=template&id=3ccb6b58"
import script from "./department-field.vue?vue&type=script&lang=js"
export * from "./department-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports